module.exports = __webpack_public_path__ + "img/TECNOLOGIA-ERTIGA-3.b64260fb.jpg";